module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-switch-search"
  }, [_c('div', {
    ref: "search",
    staticClass: "lxm-switch-search__search"
  }, [_c('lxm-search', {
    attrs: {
      "placeholder": _vm.searchPlaceholder,
      "twoLetters": _vm.twoLetters
    },
    on: {
      "submit": _vm.submit
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "summary",
    staticClass: "lxm-switch-search__summary is-clearfix"
  }, [_c('p', {
    staticClass: "is-pulled-left"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('img', {
    staticClass: "lxm-switch-search__search-img is-pulled-right",
    attrs: {
      "src": require("../../images/main/search.png")
    },
    on: {
      "click": _vm.searchClicked
    }
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0d865a06", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d865a06!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/common/LxmSwitchSearch.vue
// module id = 817
// module chunks = 0